import { useEffect, useState } from "react";
import RuletaNumero from "./ruleta";
import './anuncioSorteo.css'

const AnuncioSorteo = ({ dataInfo }) => {
    const [fechaSorteo, setFechaSorteo] = useState('Sin Asignar');
    const [tiempoRestante, setTiempoRestante] = useState('');
    const [menorA10Minutos, setMenorA10Minutos] = useState(false); // Estado para verificar si faltan menos de 10 minutos
    const [iniciarSorteo, setIniciarSorteo] = useState(null);
    const [NumeroGanador, setNumeroGanador] = useState(null)
    useEffect(()=>{
        const posicion = dataInfo.data.dataSorteos.findIndex(obj => obj.id === dataInfo.data.sorteo.id);
        if (dataInfo.data.dataSorteos[posicion].ganador){
            setNumeroGanador(dataInfo.data.dataSorteos[posicion].ganador)
            setIniciarSorteo(true)
        }
    },[dataInfo.data.dataSorteos])

    useEffect(() => {
        const posicion = dataInfo.data.dataSorteos.findIndex(obj => obj.id === dataInfo.data.sorteo.id);
        const sorteoFecha = dataInfo.data.dataSorteos[posicion]?.fecha;

        if (sorteoFecha && sorteoFecha !== 'Sin Asignar') {
            const fechaSorteoDate = new Date(sorteoFecha);
            setFechaSorteo(fechaSorteoDate.toLocaleString()); // Formatea la fecha

            const calcularTiempoRestante = () => {
                const ahora = new Date();
                const diferencia = fechaSorteoDate - ahora;

                if (diferencia <= 0) {

                    setTiempoRestante('0 minutos');
                } else {
                    const horas = Math.floor((diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
                    const segundos = Math.floor((diferencia % (1000 * 60)) / 1000);
                    setTiempoRestante(`${horas}h ${minutos}m ${segundos}`);

                    // Verificar si el tiempo restante es menor a 10 minutos
                    if (diferencia <= 100000){
                        setMenorA10Minutos(1)
                    } else if (diferencia <= 300000) { // 300,000 ms = 5 minutos
                        setMenorA10Minutos(5); // Menos de 5 minutos
                    } else if (diferencia <= 600000) { // 600,000 ms = 10 minutos
                        setMenorA10Minutos(10); // Menos de 10 minutos
                    } else {
                        setMenorA10Minutos(false); // Más de 10 minutos
                    }
                }
            };

            calcularTiempoRestante(); // Calcular el tiempo inmediatamente
            const interval = setInterval(calcularTiempoRestante, 1000); // Actualiza cada segundo

            return () => clearInterval(interval); // Limpia el intervalo al desmontar el componente
        }
    }, [dataInfo.data]);

    return (
        <div className="anuncioSorteo">
            <h1>¡Atención!</h1>
            <p>Nos complace anunciar que el sorteo de <strong>{dataInfo.data.sorteo.premio}</strong> se ha completado al 100%.</p>
            {fechaSorteo === 'Sin Asignar' && (
                <>
                    <p>En estos momentos nos encontramos verificando los parámetros del sorteo, pronto daremos la fecha y hora del sorteo.</p>
                </>
            )}
            <h3>Fecha y hora del sorteo: <strong>{fechaSorteo}</strong></h3>
            {fechaSorteo !== 'Sin Asignar' && (
                <>
                    <p>Pronto daremos inicio al sorteo.</p>
                    <p>Faltan <strong>{tiempoRestante}</strong> para el sorteo.</p>
                </>
            )}
            {menorA10Minutos && (
                <>
                    {tiempoRestante === '0 minutos' 
                    ?<h3 style={{ color: 'red', fontWeight: 'bold' }}>¡El sorteo ha Iniciado, pendiente al resultado de los numeros aca abajo👇🏿👇🏻👇🏽👇🏾👇🏾👇!</h3>
                    :<h3 style={{ color: 'red', fontWeight: 'bold' }}>¡Faltan menos de {menorA10Minutos} minutos para el sorteo!</h3>
                }
                    <RuletaNumero cantidadDigitos={dataInfo.data.sorteo.puestos.toString().length-1} numeroGanado={NumeroGanador} inicio={iniciarSorteo} dataInfo={dataInfo}/>
                </>
            )}
        </div>
    );
};

export default AnuncioSorteo;
